import React from 'react'
import { Footer } from '../Footer'

interface IProps {
	children: React.ReactNode
}

function Layout({ children, ...rest }: IProps) {
	return (
		<>
			{children}
			<Footer />
		</>
	)
}

export { Layout }
